// actions/documentActions.js
import {types} from '../types/types';

// 1) centraliza el shape
export const initialDocument = Object.freeze({
    id: 0,
    remoteId: '',
    lotFk: 0,
    customerName: '',
    documentType: 0,
    concept: 0,
    taxReceiptNumber: '',
    vatId: '',
    ncfValidUntil: '',
    number: 0,
    ordinal: 0,
    globalSequence: 0,
    subTotal: 0,
    amount: 0,
    taxAmount: 0,
    paymentAmount: 0,
    signature: '',
    deviceFk: '',
    device: {
        id: '',
        sequence: 0,
        description: '',
        status: true,
        realmFk: ''
    },
    userFk: 0,
    user: {
        id: 0,
        name: '',
        code: '',
        userName: '',
        password: '',
        permission: 0,
        realmFk: '',
        status: true
    },
    realmFk: '',
    xmlExtraField: '',
    details: [],           // ← array vacío
    payments: [],          // ← array vacío
    created: ''
});

// actions “simples”
export const setEditingDocument = (document) => ({
    type: types.editingDocumentInfo,
    payload: document
});

export const clearDocumentInfo = () => ({
    type: types.clearDocumentInfo
});
